export default __webpack_public_path__ + "static/UMWP-poziom-kolor-2015-d57213d3f45961176bdc590ea934cf1d.png";